import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function LikeColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 25'
      fill='none'
      {...props}
    >
      <path
        d='M7 11.5469L11 2.54688C11.7956 2.54688 12.5587 2.86295 13.1213 3.42555C13.6839 3.98816 14 4.75123 14 5.54688V9.54688H19.66C19.9499 9.54359 20.2371 9.60338 20.5016 9.72209C20.7661 9.84081 21.0016 10.0156 21.1919 10.2344C21.3821 10.4532 21.5225 10.7107 21.6033 10.9891C21.6842 11.2676 21.7035 11.5602 21.66 11.8469L20.28 20.8469C20.2077 21.3238 19.9654 21.7585 19.5979 22.0709C19.2304 22.3833 18.7623 22.5523 18.28 22.5469H7M7 11.5469V22.5469M7 11.5469H4C3.46957 11.5469 2.96086 11.7576 2.58579 12.1327C2.21071 12.5077 2 13.0164 2 13.5469V20.5469C2 21.0773 2.21071 21.586 2.58579 21.9611C2.96086 22.3362 3.46957 22.5469 4 22.5469H7'
        stroke='url(#paint0_linear_938_15212)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_938_15212'
          x1='2'
          y1='2.54687'
          x2='22.4047'
          y2='3.3129'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FE901F' />
          <stop offset='1' stopColor='#A94AC7' />
        </linearGradient>
      </defs>
    </svg>
  );
}
